package com.shadowings.gero.data.lessons.chapter2
import com.shadowings.gero.data.lessons.buildVocabContent
import com.shadowings.gero.data.lessons.buildVocabQuizContent


import com.shadowings.gero.domain.model.IExplanation
import com.shadowings.gero.domain.model.IQuizContent
import com.shadowings.gero.domain.model.ImageKeyboardContent
import com.shadowings.gero.presentation.model.Word
import gero.composeapp.generated.resources.Res
import gero.composeapp.generated.resources.exp_content_impariamo_alcune_parole_base_sugli_animali
import gero.composeapp.generated.resources.exp_content_vocab_animali_miit
import gero.composeapp.generated.resources.exp_title_vocabolario_animali

val animalNames = listOf(
    "FALCO",
    "COBRA",
    "UCCELLO",
    "PESCE",
    "TORO",
    "MUCCA",
    "GATTO",
    "GATTA"
)

fun getVocabAnimalsContent(words: List<Word>, languageCode: String): List<IExplanation> {
    return buildVocabContent(
        lessonTitle = Res.string.exp_title_vocabolario_animali,
        lessonIntro = Res.string.exp_content_impariamo_alcune_parole_base_sugli_animali,
        wordIds = animalNames,
        words = words,
        languageCode = languageCode
    )
}

// Inscription photo (image code, word id, caption) with the word highlighted by a red box.
private val animalInscriptions = listOf(
    Triple("miit", "GATTA", Res.string.exp_content_vocab_animali_miit),
)

fun getVocabAnimalsQuizContent(
    explanations: List<IExplanation>,
    words: List<Word>,
    languageCode: String
): List<IQuizContent> {
    val vocabQuizzes = buildVocabQuizContent(
        explanations = explanations,
        words = words,
        languageCode = languageCode
    )
    val inscriptionQuizzes = animalInscriptions.mapNotNull { (imageCode, wordId, caption) ->
        val word = words.firstOrNull { it.id == wordId } ?: return@mapNotNull null
        ImageKeyboardContent(
            imageCode = imageCode,
            reading = word.reading.lowercase().map { it.toString() },
            translation = caption
        )
    }
    return (vocabQuizzes + inscriptionQuizzes).shuffled()
}
